import {
  ASSOCIATION_TYPES_GDA_PRE_V261,
  ASSOCIATION_TYPES_VDA_PRE_V261,
  LEGACY_ASSOCIATION_TYPES_GDA,
  LEGACY_ASSOCIATION_TYPES_VDA,
  RELATION_EXTRACTION_ASSOCIATION_TYPES,
} from '@/components/About/constants';
import { formatAssociationType } from './formatAssociationType';

const EXTENDED_ASSOCIATION_TYPES_GDA = [
  'Drug Response Variant',
  'Protective Variant',
  'Modifying Mutation',
  'Somatic Modifying Mutation',
  'SomaticModifyingMutation',
  'Germline Modifying Mutation',
  'Genomic Alterations',
  'Genetic Variation',
  'therapeutic',
  'TherapeuticTarget',
] as const;

const EXTENDED_ASSOCIATION_TYPES_VDA = [
  'Drug Response Variant',
  'Protective Variant',
  'Genetic Variation',
] as const;

export function normalizeAssociationTypeToken(value: string): string {
  return value.toLowerCase().replace(/[\s_\-]+/g, '');
}

export function buildAssociationTypeFilterOptions(...groups: readonly (readonly string[])[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];

  for (const group of groups) {
    for (const type of group) {
      const key = normalizeAssociationTypeToken(formatAssociationType(type));
      if (!seen.has(key)) {
        seen.add(key);
        result.push(type);
      }
    }
  }

  return result.sort((a, b) => formatAssociationType(a).localeCompare(formatAssociationType(b)));
}

/** Full GDA association-type filter list (independent of release feature flags). */
export const ASSOCIATION_TYPES_GDA_FILTER = buildAssociationTypeFilterOptions(
  RELATION_EXTRACTION_ASSOCIATION_TYPES,
  LEGACY_ASSOCIATION_TYPES_GDA,
  EXTENDED_ASSOCIATION_TYPES_GDA,
  ASSOCIATION_TYPES_GDA_PRE_V261,
);

/** Full VDA association-type filter list (independent of release feature flags). */
export const ASSOCIATION_TYPES_VDA_FILTER = buildAssociationTypeFilterOptions(
  RELATION_EXTRACTION_ASSOCIATION_TYPES,
  LEGACY_ASSOCIATION_TYPES_VDA,
  EXTENDED_ASSOCIATION_TYPES_VDA,
  ASSOCIATION_TYPES_VDA_PRE_V261,
);

export function dropdownFilterMatchesSearch(
  option: { id?: string; label?: string },
  searchTerm: string,
): boolean {
  if (!searchTerm) return true;

  const normalizedTerm = normalizeAssociationTypeToken(searchTerm);
  const label = option.label ?? '';
  const id = option.id ?? '';
  const lowerTerm = searchTerm.toLowerCase();

  return (
    normalizeAssociationTypeToken(label).includes(normalizedTerm) ||
    normalizeAssociationTypeToken(id).includes(normalizedTerm) ||
    label.toLowerCase().includes(lowerTerm) ||
    id.toLowerCase().includes(lowerTerm)
  );
}
